// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-down.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/arrow-down'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowDownIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
